import React from 'react';
import { FaCog, FaSpinner } from 'react-icons/fa';

export function InvitationSettingsModal({ 
  show, 
  invitationSettings, 
  setInvitationSettings, 
  savingSettings, 
  onSave, 
  onClose 
}) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center px-4 z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6" data-testid="invitation-settings-modal">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-3 bg-blue-100 rounded-full">
            <FaCog className="text-blue-600 text-xl" />
          </div>
          <h3 className="text-2xl font-bold text-gray-800">Invitation Settings</h3>
        </div>
        
        <p className="text-gray-600 mb-6">
          Control how new members can be invited to join your family.
        </p>
        
        <div className="space-y-4">
          {/* Allow all members to invite */}
          <label className="flex items-start space-x-3 p-4 bg-gray-50 rounded-lg cursor-pointer hover:bg-gray-100 transition">
            <input
              type="checkbox"
              checked={invitationSettings.allow_all_members_to_invite}
              onChange={(e) => setInvitationSettings({
                ...invitationSettings,
                allow_all_members_to_invite: e.target.checked
              })}
              className="mt-1 w-5 h-5 text-blue-600 rounded focus:ring-blue-500"
              data-testid="allow-all-invite-checkbox"
            />
            <div>
              <span className="font-medium text-gray-800">Allow all members to invite</span>
              <p className="text-sm text-gray-500 mt-1">
                When enabled, any family member can send invitations to proxy members. 
                When disabled, only you (the owner) can send invitations.
              </p>
            </div>
          </label>
          
          {/* Require owner approval */}
          <label className="flex items-start space-x-3 p-4 bg-gray-50 rounded-lg cursor-pointer hover:bg-gray-100 transition">
            <input
              type="checkbox"
              checked={invitationSettings.require_owner_approval}
              onChange={(e) => setInvitationSettings({
                ...invitationSettings,
                require_owner_approval: e.target.checked
              })}
              className="mt-1 w-5 h-5 text-blue-600 rounded focus:ring-blue-500"
              data-testid="require-approval-checkbox"
            />
            <div>
              <span className="font-medium text-gray-800">Require owner approval</span>
              <p className="text-sm text-gray-500 mt-1">
                When enabled, invited members must be approved by you before they can access the family. 
                When disabled, they're automatically added once they create an account.
              </p>
            </div>
          </label>
        </div>

        {/* Info box */}
        <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
          <p className="text-sm text-blue-800">
            <strong>Current policy:</strong>{' '}
            {invitationSettings.allow_all_members_to_invite 
              ? 'Any member can invite' 
              : 'Only owner can invite'}.{' '}
            {invitationSettings.require_owner_approval 
              ? 'New members require your approval.' 
              : 'New members are added automatically.'}
          </p>
        </div>

        <div className="flex space-x-4 mt-6">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={onSave}
            disabled={savingSettings}
            className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 flex items-center justify-center space-x-2"
            data-testid="save-settings-btn"
          >
            {savingSettings ? (
              <>
                <FaSpinner className="animate-spin" />
                <span>Saving...</span>
              </>
            ) : (
              <span>Save Settings</span>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
